
import type { PropType } from 'vue'
import type { ConflictDisplayData } from './types'
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ConflictErrorList',
  components: {},
  props: {
    conflicts: {
      type: Array as PropType<Array<ConflictDisplayData>>,
      default: () => [],
    },
  },
  setup() {
    const baseClass = 'conflict-error-list'
    return { baseClass }
  },
})
